const zoomImage = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$zoomImage = $('.js-zoomImage');
	},

	bindEvents: function() {
		this.ui.$zoomImage.on('click', this.toggleZoom.bind(this));
		this.ui.$zoomImage.on('mousemove', this.zoom.bind(this));
		this.ui.$zoomImage.on('mousemove touchmove', this.zoom.bind(this));
	},

	toggleZoom: function(e) {
		var $this = $(e.currentTarget);
		$this.toggleClass("zoomed");
	},

	zoom: function(e){
		var zoomer = e.currentTarget;
		var offsetX = 0;
		var offsetY = 0;
		if(e.offsetX){
			offsetX = e.offsetX;
			offsetY = e.offsetY;
			var x = offsetX/zoomer.offsetWidth*100;
			var y = offsetY/zoomer.offsetHeight*100;
			zoomer.style.backgroundPosition = x + '% ' + y + '%';
		}else{
			var zoomerRect = zoomer.getBoundingClientRect();
			offsetX = e.touches[0].pageX-zoomerRect.x;
			offsetY = e.touches[0].pageY-zoomerRect.y;
			var x = offsetX/zoomer.offsetWidth*100;
			var y = offsetY/zoomer.offsetHeight*100;
			// patch weird touch bug, todo real fix later
			if(x>100){x = 100;}
			if(y>100){y = 100;}
			if(x<0){x = 0;}
			if(y<0){y = 0;}
			zoomer.style.backgroundPosition = x + '% ' + y + '%';
		}
	}
};

module.exports = zoomImage;